import styled from "styled-components";
import {TextField} from "@material-ui/core";

export const FullWidthTextField = styled(TextField)`
    width: 100%;
`;

export const ShowLabel = styled.div`
    margin-left: 16px;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    span {
        font-size: 14px;
        color: var(--mdc-theme-primary);
        :hover {
            cursor: pointer;
            opacity: 0.8;
        }
    }
`;